import React, {Component} from "react";
import ReactDOM from "react-dom";
import LoadingOverlay from "react-loading-overlay";
import SimpleButton from "../commons/SimpleButton";
import FlexView from "react-flexview";

LoadingOverlay.propTypes = undefined;

class SimpleAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            container: null,
        };
    }

    componentDidMount() {
            const app = document.getElementsByClassName("app");
            if (app.length > 0) {
                this.setState({
                    container: app[0],
                });
            }
    }

    render() {
        const {title, loading, visible, content, styles, onClickClose, additionalButtons} = this.props;

        if (!visible || !this.state.container) {
            return null;
        }

        return ReactDOM.createPortal(
            <div
                className="app-popup app-popup-show"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <div
                    className="popup-content background-white border-radius"
                    style={{
                        width: "30%",
                        ...styles
                    }}
                >
                    <LoadingOverlay active={loading} spinner>
                        <div id="header" className="popup-panel grid grid-2x">
                            <div className="col-1">
                                <div className="popup-title">{title}</div>
                            </div>
                            <div className="col-2 content-right">
                                <button
                                    className="btn btn-circle btn-grey"
                                    onClick={onClickClose}
                                >
                                    <i className="fa fa-lg fa-times"/>
                                </button>
                            </div>
                        </div>
                        <div id="body">
                            <FlexView column style={{
                                gap: '2rem',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '1rem',
                            }}>
                                <span style={{textAlign: 'center'}}>{content}</span>
                                {/* <span style={{textAlign: 'center'}} dangerouslySetInnerHTML={{__html: content}}></span> */}
                                {additionalButtons}
                            </FlexView>
                        </div>
                    </LoadingOverlay>
                </div>
            </div>,
            this.state.container
        );
    }
}

SimpleAlert.defaultProps = {
    loading: false,
};

export default SimpleAlert;
